<template>
  <div class="chaining">
    <el-scrollbar style="height: 100%">
      <el-form ref="form" :model="form" label-width="80px" label-position="top" size="small">
        <el-form-item label="编链类型">
          <el-select v-model="form.type" clearable placeholder="请选择编链类型" @change="typeChange">
            <el-option label="药物治疗" :value="1"></el-option>
            <el-option label="功能训练" :value="2"></el-option>
            <el-option label="随访计划" :value="3"></el-option>
            <el-option label="评估方案" :value="4"></el-option>
            <el-option label="复诊计划" :value="5"></el-option>
            <el-option label="日常提醒" :value="6"></el-option>
            <el-option label="疗程管理师任务" :value="7"></el-option>
            <el-option label="健康宣教" :value="8"></el-option>
            <el-option label="运动处方" :value="9"></el-option>
            <el-option label="重点指标" :value="10"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称">
          <el-select v-model="form.name" filterable clearable placeholder="请输入关键词搜索名称" @change="addTableData">
            <el-option :label="`${item.itemName} ${item.cycleStr}`" :value="item.id"
              v-for="(item, key) in schemeList" :key="key">
              <span class="itemname-select" :title="item.itemName">{{ item.itemName }}</span>
              <span style="vertical-align:top">{{ item.cycleStr }}</span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="chaining-result" v-if="tableData.length">
        <span class="sign">* 可拖动结果至画布的输出框中</span>
        <table class="table-chaining">
          <thead>
            <tr>
              <th v-for="(item, key) in column" :key="key" :class="`${item.props} text`">{{ item.label }}</th>
            </tr>
          </thead>
          <tbody v-if="tableData.length">
            <tr v-for="(item, key) in tableData" :key="key" draggable @dragstart="(e)=>{dragstart(e,item)}">
              <el-tooltip class="item" effect="dark" :content=" item.itemType !== 8 ? item.itemName : item.courseName "
                placement="top-start" v-if="item.itemType !== 8 ? item.itemName : item.courseName">
                <td :class="`text`">{{ item.itemType !== 8 ? item.itemName : item.courseName }}</td>
              </el-tooltip>
              <td :class="`text`" v-else>{{  item.itemType !== 8 ? item.itemName : item.courseName  }}</td>
              <el-tooltip class="item" effect="dark" :content="item.cycleStr" placement="top-start"
                v-if="item.cycleStr">
                <td :class="`text`">{{ item.cycleStr }}</td>
              </el-tooltip>
              <td :class="`text`" v-else>{{ item.cycleStr }}</td>
              <td :class="`text`">{{ item.time }}</td>
              <td class="oprate">
                <span @click="deleteHandle(item)">删除</span>
                <span @click="handleEdit(item)">编辑</span>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="empty" v-if="!tableData.length">
          暂无数据……
        </div>
      </div>
    </el-scrollbar>
    <!-- 动态组件-->
    <component :is="componentsName" :visible="editModel" :formData="detail" :startTimeTypeList="startTimeTypeList" @updateTemplate="updateTemplate">
    </component>
  </div>
</template>

<script>

import {
  getSchemeItemBySchemeTypeAndName,
  createSchemeItemTemplate,
  getSchemeItemTemplateList,
  getTemplateDetail,
  updateSchemeItemTemplate,
  getTemplateDelete
} from "./api/index";
import { getTimeAxisList } from "@/api/timeAxis";

export default {
  data() {
    return {
      form: {
        type: "",
        name: ""
      },
      schemeList: [],
      column: [
        {
          props: "itemName",
          label: "名称"
        },
        {
          props: "cycle",
          label: "频率"
        },
        {
          props: "time",
          label: "时长"
        },
        {
          props: "oprate",
          label: "操作"
        }
      ],
      tableData: [],
      editModel: false,
      title: "药物治疗方案",
      componentsName: "DailyReminders",
      detail: {
        attrs: 2,
        moduleCode: "JRTX",
        isTop: 2,
        shortDaysType: "天",
        startIntervalType: "天"
      },
      collectStartTimeList: [
        {
          value: 1,
          label: "服务启动时间"
        },
        {
          value: 3,
          label: "入案时间"
        },
        {
          value: 5,
          label: "入院时间"
        },
        {
          value: 6,
          label: "手术时间"
        },
        {
          value: 7,
          label: "出院时间"
        },
        {
          value: 8,
          label: "线上随访时间"
        },
        {
          value: 9,
          label: "线下随访时间"
        },
        {
          value: 10,
          label: "服务结束时间"
        },
        {
          value: 11,
          label: "化疗时间"
        },
        {
          value: 12,
          label: "触发时间"
        },
        {
          value: 20,
          label: "门诊就诊时间"
        },
        {
          value: 21,
          label: "预产期时间"
        },
        {
          value: 22,
          label: "末次月经时间"
        },
        {
          value: 23,
          label: "辅助生殖手术时间"
        },
        {
          value: 24,
          label: "就诊时间"
        },
        {
          value: 25,
          label: "开方时间"
        },
        {
          value: 26,
          label: "报告时间"
        },
        {
          value: 27,
          label: "检查时间"
        },
        {
          value: 28,
          label: "留观时间"
        },
        {
          value: 29,
          label: "抢救时间"
        },
        {
          value: 30,
          label: "筛查评估时间"
        },
        {
          value: 31,
          label: "会诊日期时间"
        },
        {
          value: 32,
          label: "随访时间"
        },
        {
          value: 33,
          label: "事件发生时间"
        },
        {
          value: 34,
          label: "促排时间"
        },
        {
          value: 35,
          label: "取卵时间"
        },
        {
          value: 36,
          label: "移植时间"
        },
        {
          value: 37,
          label: "放疗时间"
        }
      ],
      startTimeTypeList:[]
    };
  },
  components: {
    Medicine: () => import("./components/Medicine.vue"), // 药物治疗
    VisitPlan: () => import("./components/VisitPlan.vue"), // 复诊计划
    Training: () => import("./components/Training.vue"), // 功能训练
    SportPrescription: () => import("./components/SportPrescription.vue"), // 运动处方
    Assessment: () => import("./components/Assessment.vue"), // 评估方案
    ManagerTasks: () => import("./components/ManagerTasks.vue"), // 疗程管理师任务方案
    HealthEducation: () => import("./components/HealthEducation.vue"), // 健康宣教
    FollowPlan: () => import("./components/FollowPlan.vue"), // 随访计划
    DailyReminders: () => import("./components/DailyReminders.vue"), // 日常提醒
    KeyIndicators: () => import("./components/KeyIndicators.vue") // 重点指标
  },
  created() {
    this.initTableData();
  },
  methods: {
    async initTableData() {
      let decisionTreeObj = JSON.parse(localStorage.getItem("decisionTreeObj")),
        decisionTreeId = decisionTreeObj.decisionTreeId;
      // treeType = decisionTreeObj.pageName === 'templatePage' ? 1 : decisionTreeObj.pageName === 'patientPage' ? 2 : decisionTreeObj.pageName === 'doctorPage' ? 3 : ''

      // 模板编辑：templatePage 患者编辑：patientPage
      let { code, data } = await getSchemeItemTemplateList({ decisionTreeId });
      if (code === 0) {
        this.tableData = data.map(items => {
          return {
            ...items,
            time:
              items.attrs === 2 ? items.shortDays + items.shortDaysType : "长期"
          };
        });
      }
    },
    typeChange(val) {
      this.editModel = false;
      this.getSchemeItem(this.form.name, val);
    },
    async getSchemeItem(name, type) {
      let { data, code } = await getSchemeItemBySchemeTypeAndName({
        name,
        type
      });
      if (code === 0) {
        this.schemeList = data;
      }
    },
    async addTableData(val) {
      let decisionTreeObj = JSON.parse(localStorage.getItem("decisionTreeObj")),
        decisionTreeId = decisionTreeObj.decisionTreeId,
        treeType =
          decisionTreeObj.pageName === "templatePage"
            ? 1
            : decisionTreeObj.pageName === "patientPage"
            ? 2
            : decisionTreeObj.pageName === "doctorPage"
            ? 3
            : "";
      this.editModel = false;
      let params = this.schemeList.filter(item => {
        if (val === item.id) {
          return item;
        }
      });

      let { data, code } = await createSchemeItemTemplate({
        ...params[0],
        decisionTreeId,
        treeType
      });
      if (code === 0) {
        // 调用列表接口
        this.form.name = "";
        this.initTableData();
      }
    },
    // 更新模板信息
    async updateTemplate(params) {
      let { code, data } = await updateSchemeItemTemplate({
        id: this.detail.id,
        ...params
      });
      if (code === 0 && data === true) {
        this.$message.success(`${this.transType(params.itemType)}更新完成`);
        this.editModel = false;
        this.initTableData();
      }
    },
    // 删除
    async deleteHandle(row) {
      this.editModel = false;
      let { code, data } = await getTemplateDelete(row.id);
      if (code === 0) {
        this.$message.success("删除成功");
        this.initTableData();
      }
    },
    async getTimeAxisData(refId) {
      let res = await getTimeAxisList({
        refId: refId,
        schemeType: 1
      });
      if (res.code === 0) {
        this.startTimeTypeList = res.data;
      }
    },
    async handleEdit(row) {
      this.componentsName = this.transItemType(row.itemType);
      this.editModel = true;
      // 详情
      let { code, data } = await getTemplateDetail(row.id);
      if (code === 0) {
        this.detail = data;
        // this.detail.itemTime = this.$timeNumFun(data.remindDate);
        this.$set(this.detail,'itemTime',this.$timeNumFun(data.remindDate))
        this.getTimeAxisData(data.schemeId)
      }
      // 判断展示哪个组件
      // this.componentsName = '组件名称'
    },
    dragstart(e, item) {
      //对接完数据后在这里处理最终需要拖入的数据格式,如下obj：
      let obj = {
        nodeType: 2, // 1,"输入",2,"输出",3,"条件",4,"通知",
        outputType: 4, // 1,"文本",2,"问卷",3,"宣教",4.编链
        displayContent: item, //// 输出内容显示值
        outputContent: JSON.stringify(item) //输出实际值
      };
      e.dataTransfer.setData("user", JSON.stringify(obj));
    },
    transItemType(type) {
      switch (type) {
        case 1:
          return "Medicine";
          break;
        case 2:
          return "Training";
          break;
        case 3:
          return "FollowPlan";
          break;
        case 4:
          return "Assessment";
          break;
        case 5:
          return "VisitPlan";
          break;
        case 6:
          return "DailyReminders";
          break;
        case 7:
          return "ManagerTasks";
          break;
        case 8:
          return "HealthEducation";
          break;
        case 9:
          return "SportPrescription";
        case 10:
          return "KeyIndicators";
          break;
      }
    },
    transType(type) {
      switch (type) {
        case 1:
          return "药物治疗方案";
          break;
        case 2:
          return "功能训练方案";
          break;
        case 3:
          return "随访计划方案";
          break;
        case 4:
          return "评估方案";
          break;
        case 5:
          return "复诊计划方案";
          break;
        case 6:
          return "日常提醒方案";
          break;
        case 7:
          return "疗程管理师任务方案";
          break;
        case 8:
          return "健康宣教方案";
          break;
        case 9:
          return "运动处方方案";
        case 10:
          return "重点指标收集任务";
          break;
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "./index.less";
.itemname-select {
  display: inline-block;
  width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space:nowrap;
}
</style>